import { Component, ChangeDetectionStrategy } from "@angular/core";
import { BaseFieldComponent } from "../../utils/base-field.component";
import { BaseFieldHtmlComponent } from "../../utils/base-field-html.component";
import { ReactiveFormsModule } from "@angular/forms";
import { NgSelectComponent } from "@ng-select/ng-select";
import { NgClass } from "@angular/common";

@Component({
  selector: 'app-select-field',
  standalone: true,
  templateUrl: './select-field.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    BaseFieldHtmlComponent,
    ReactiveFormsModule,
    NgSelectComponent,
    NgClass
  ]
})

export class SelectFieldComponent extends BaseFieldComponent {

}
